const loginModule = {
    login: "ログイン",
    phonePlaceholder: "携帯番号を入力してください",
    emailPlaceholder: "メールを入力してください",
    passwordPlaceholder: "パスワードを入力してください",
    register: "新規会員登録",
    forgetText: "パスワードを忘れた場合",
    ruleText1: "利用規約",
    ruleText2: "個人情報の取り扱い",
    ruleText3: "に同意する",
    questionText: "ログインにお困りの方",
    questionSubText: "ご利用いただける機能に一部制限があります",
    otherLogin: "または",
    otherLoginText: "その他のログイン",
    routeLoading: "スイッチング中...",
    rule: "個人情報の取り扱いについて",
    returnLogin: "ログアウトする",
    visitorsLogin: "ゲストとして利用",
    agentWarn: "シークレットモード使用、もしくは閲覧履歴データを削除する場合、過去の注文情報が保存されませんので、ご注意ください。",
    emailPlaceholder: "メールアドレスをご入力ください",
    accountExample: "ID(例：08012341234)",
    lineLogin: "LINEでログイン",
    lineLoginDesc: "LINEで簡単利用する場合、「LINEでログイン」をクリック、「許可する」を押してください。",
    nohaveAccount: "LINEを使用していない方は、こちらより登録してください"
};

export default loginModule;
